export const UserDefineValidation = (formData) => {
    const errors = {};
    debugger;
    // Validate each field
    if (formData.ModuleID==="0" || formData.ModuleID===0) {
        errors.ModuleID = 'This field is required';
    }
    if (formData.FK_KeyType_ID === "0" || formData.FK_KeyType_ID===0) {
        errors.FK_KeyType_ID = 'This field is required';
    }
    if (!formData.vc_Name) {
        errors.vc_Name = 'This field is required';
    }

    return errors;
};

